import { render } from "./App.vue?vue&type=template&id=d458bbde"
const script = {}

import "./App.vue?vue&type=style&index=0&id=d458bbde&lang=scss"
script.render = render

export default script